import { AnalysisIssueList } from '@/components/Studies/Groups/Analysis/AnalysisIssueList';
import { type AnalysisIssue } from '@/model/Analysis.model.ts';
import { type FC } from 'react';
import { ModalActions, ModalContainer, ModalHeader, useModalAction } from '@/utils/modal';

interface GraphIssuesModalProps {
  issues: Array<AnalysisIssue>;
}

export const GraphIssuesModal: FC<GraphIssuesModalProps> = ({ issues }) => {
  const { closeModal } = useModalAction();

  return (
    <ModalContainer size="small">
      <ModalHeader title={`Issue${issues.length > 1 ? 's' : ''} detected`} className="pa3 bb b--moon-gray bg-white" />
      <div className="pv3 ph2">
        <AnalysisIssueList issues={issues} />
      </div>
      <ModalActions className="pa3 bt b--moon-gray" cancelBtnText="Close" onCancel={closeModal} />
    </ModalContainer>
  );
};
